function DumbContainer({children}){

    return (
        children
    )
}

export default DumbContainer